<template>
  <div class="row">
    <div class="col-lg-12">

      <!-- HEADER DO COMPROMISSO -->
      <div class="compromisso-header">

        <!-- Linha: Período e Título -->
        <h1 class="titulo-compromisso">
          {{ model.periodo }} {{ model.descritivo }}
        </h1>

        <!-- Linha: Descrição e Status lado a lado -->
        <div class="descricao-status">
          <div></div>
          <span class="label-status" :class="statusClass(model.status)">
            {{ model.status }}
          </span>
        </div>

        <!-- Linha: Unidade -->
        <p class="info-sub"><strong>Unidade:</strong> {{ model.unidade_executora }}</p>

        <!-- Linha: Responsável -->
        <p class="info-sub">
          <strong>Responsável:</strong> {{ model.nome_responsavel }}
        </p>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list 
            ref="vuetable" 
            :show-empty="true" 
            title="Ações vinculadas ao compromisso"
            :api-url="`planogoverno/compromisso-acao?compromisso_id=${id}`" 
            report-title="Ações do compromisso"
            :fields="fields"
            :initial-page="pagina" 
            :pageCollection="'compromissoDetails'"
            :append-params="filtros"
          >
            <template slot="filters">
              <div class="collapse" id="filtros">
                <div class="col-sm-2">
                  <label for="unidade_filter" class="custom-font">Unidades</label>
                  <div class="custom-select">
                    <select 
                      v-model="unidade" 
                      @change="consultar" 
                      ref="unidade_filter" 
                      name="unidade_filter"
                      class="form-control select-selected"
                    >
                      <option value="">Todas</option>

                      <option 
                        v-for=" unidade in unidadesDisponiveis"
                        :key="unidade"
                        :value="unidade"
                      >
                        {{ unidade }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-5">
                  <label for="descritivo_filter" class="custom-font">Descritivo</label>
                  <input
                    type="text"
                    v-model="descritivo"
                    @change="consultar"
                    ref="descritivo_filter"
                    name="descritivo_filter"
                    class="form-control"
                    placeholder="Buscar por descrição"
                  />
                </div>
                <div class="col-sm-5">
                  <label for="status-filter" class="custom-font">Status</label>
                  <div class="custom-select">
                    <select 
                      v-model="status" 
                      @change="consultar" 
                      ref="status_filter" 
                      name="status_filter"
                      class="form-control select-selected"
                    >
                      <option value='' selected>
                        Todos
                      </option>
                      <option v-for="status in listas.status" :key="status" :value="status">
                        {{ status }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12">
                  <button @click="consultar()" class="btn btn-default margem-topo" name="btnFiltrar">
                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                    Filtrar
                  </button>
                  <button @click="limpar()" class="btn btn-default margem-topo" name="btnLimpar">
                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </template>

            <template slot="actions">
              <router-link class="btn btn-default" :to="{ name: 'admin_planogoverno_acao_save', params: { id: this.id } }" :disabled="model.status === 'Cancelado' || model.status === 'Concluído'">
                <i class="fa fa-plus" aria-hidden="true"></i> Adicionar
              </router-link>
              <button class="btn btn-default" data-toggle="collapse" data-target="#filtros">
                <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
              </button>
            </template>

            <template slot="rowrender" slot-scope="props">
              <div>
                <button 
                  title="Informações"
                  type="button"
                  class="btn btn-primary"
                  @click="detalhar(props.rowData)"
                >
                  <font-awesome-icon :icon="'info'" class="icon" />
                </button>

                <router-link 
                  title="Editar" 
                  class="btn btn-primary"
                  :disabled="props.rowData.status !== 'Não Iniciado'"
                  :to="{
                    name: 'admin_planogoverno_acao_edit',
                    params: { id: props.rowData.id }
                  }"
                >
                  <font-awesome-icon :icon="'edit'" />
                </router-link>

                <button 
                  type="button" 
                  title="Deletar" 
                  class="btn btn-primary" 
                  @click="deleteAcao(props.rowData)"
                >
                  <font-awesome-icon :icon="'trash-alt'" />
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>

      <SideAcao
        ref="side"
        :navs="sideConfig"
        @deletar="confirmarDelete"
      />

      <!-- Botão voltar -->
      <button 
        class="btn btn-default"
        @click="$router.back()"
      >
        <font-awesome-icon icon="arrow-left" /> Voltar
      </button>

    </div>
  </div>
</template>


<script>
import { request } from '@/request'
import list from '@/components/common/DataTable'
import SideAcao from '@/components/planogoverno/SideAcao.vue'

export default {
  name: 'compromisso-details',
  props: ['id'],
  components: { list, SideAcao },
  data() {
    return {
      model: {
        id: null,
        descritivo: '',
        unidade_executora: '',
        periodo: '',
        user_sshd: '',
        responsavel_sshd: '',
        data_conclusao: '',
        status: ''
      },
      fields: [
        {
          name: 'unidade',
          title: 'Unidade',
          sortField: 'unidade',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'descritivo',
          title: 'Descritivo',
          sortField: 'descritivo',
          dataClass: 'align-middle truncate-multiline',
          filterable: true,
          callback(value) {
            if (!value) return ''
             return value.length > 150 ? value.substring(0, 97) + '...' : value
          }
        },
        {
          name: 'data_estimada_inicio',
          title: 'Inicia',
          sortField: 'data_estimada_inicio',
          titleClass: 'text-center',
          dataClass: 'text-center align-middle',
          filterable: true
        },
        {
          name: 'data_estimada_conclusao',
          title: 'Finaliza',
          sortField: 'data_estimada_conclusao',
          titleClass: 'text-center',
          dataClass: 'text-center align-middle',
          filterable: true
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          titleClass: 'text-center text-nowrap',
          dataClass: 'text-center text-nowrap',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ],
      sideConfig: [
        {
          titulo: 'Detalhes',
          subtitulo: '',
          subtDetalhe: '',
          largura: 600,
          identidade: 'detalhes',
          abreProximo: false,
          aberto: false,
          data: null
        },
        {
          titulo: 'Excluir',
          subtitulo: '',
          subtDetalhe: '',
          largura: 600,
          identidade: 'deletar',
          abreProximo: false,
          aberto: false,
          data: null
        }
      ],
      listas: {
        status: [
          'Não Iniciado', 
          'Em andamento', 
          'Concluído', 
          'Cancelada', 
          'Rejeitada'
        ]
      },
      unidadesDisponiveis: [],
      responsaveisCache: {}
    }
  },
  created() {
    this.carregarDetalhes()
    this.carregarOpcoesUnidades()
  },
  computed: {
    filtros() {
      return {
        descritivo: this.descritivo,
        unidade:   this.unidade,
        status:    this.status
      }
    },
    pagina: {
      get() {
        const { compromissoDetails } = this.$store.state.vuetableState
        const { pagina } = compromissoDetails
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'compromissoDetails',
          value: value
        })
      }
    },
    unidade: {
      get() {
        return (
          this.$store.state.vuetableState
            .compromissoDetails
            .filtros
            .unidade
          || ''
        )
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'unidade',
          collection: 'compromissoDetails',
          value: value
        })
        this.resetPageStore()
      }
    },
    descritivo: {
      get() {
        return (
          this.$store.state.vuetableState
            .compromissoDetails
            .filtros
            .descritivo
          || ''
        )
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'descritivo',
          collection: 'compromissoDetails',
          value: value
        })
        this.resetPageStore()
      }
    },
    status: {
      get() {
        return (
          this.$store.state.vuetableState
            .compromissoDetails
            .filtros
            .status
          || ''
        )
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'status',
          collection: 'compromissoDetails',
          value: value
        })
        this.resetPageStore()
      }
    }
  },
  methods: {
    async carregarDetalhes() {
      const { data } = await request.get(`planogoverno/compromisso/${this.id}`)

      if (data && data.responsavel_sshd) {
        data.nome_responsavel = await this.obterNomeResponsavel(data.responsavel_sshd)
      }

      this.model = data
    },
    async carregarOpcoesUnidades() {
      try {
        const { data: { data: todasAsAcoes } } = await request.get(`planogoverno/compromisso-acao?compromisso_id=${this.id}`)

        if (todasAsAcoes && todasAsAcoes.length) {
          const unidades = new Set(todasAsAcoes.map(acao => acao.unidade))
          this.unidadesDisponiveis = Array.from(unidades).sort()
        }
      } catch (err) {
        console.error("Erro ao carregar opções de unidades para o filtro: ", err);
        this.$toastr.e('Não foi possível carregar as opções de filtro de unidade.');
      }
    },
    async obterNomeResponsavel(sshd) {
      if (!sshd) {
          return 'Não encontrado';
      }

      if (this.responsaveisCache[sshd.toUpperCase()]) {
        return this.responsaveisCache[sshd.toUpperCase()];
      }

      try {
        const responsaveis = await this.loadResponsaveis([sshd.toUpperCase()]);
        const nome = responsaveis[0] ? responsaveis[0].nome : 'Não encontrado';
        this.responsaveisCache[sshd.toUpperCase()] = nome;
        return nome;
      } catch (err) {
        console.error("Erro ao obter nome do responsável:", err);
        return sshd;
      }
    },
    async loadResponsaveis(listaSSHD) {
      if (!listaSSHD || listaSSHD.length === 0) {
        return [];
      }

      try {
        const { status, data } = await request.get(`/funcionario?sshd=${listaSSHD.join(',')}`);
        if (status !== 200) {
          return [];
        }

        return data
      } catch (err) {
        console.error("Erro ao carregar responsáveis:", err);
        return [];
      }
    },
    async detalhar(acao) {
      this.sideConfig[0].subtitulo = acao.descritivo
      this.sideConfig[0].data = acao
      this.sideConfig[0].data.nome_responsavel = await this.obterNomeResponsavel(acao.sshd_responsavel)
      this.$refs.side.$emit('abreModal', 'detalhes')
    },
    async deleteAcao(acao) {
      this.sideConfig[1].subtitulo = acao.descritivo
      this.sideConfig[1].data = acao;
      this.$refs.side.$emit('abreModal', 'deletar')
    },
    async confirmarDelete(id) {
      try {
        await request.delete(`planogoverno/compromisso-acao/${id}`)
        this.$refs.vuetable.refresh()
        this.$toastr.s('Ação excluída com sucesso.')
        this.$refs.side.$emit('fechaModal', 'deletar')
      } catch (err) {
        console.error("Erro ao excluir a ação: ", err);
      }
    },
    formatarData(data) {
      if (!data) return '-'
      return new Date(data).toLocaleDateString('pt-BR')
    },
    statusClass(status) {
      switch (status) {
        case 'Não Iniciado':
          return 'label-nao-iniciado'
        case 'Em andamento':
          return 'label-em-andamento'
        case 'Concluído':
          return 'label-concluido'
        case 'Cancelado':
          return 'label-cancelado'
        default:
          return 'label-nao-iniciado'
      }
    },
    consultar() {
      this.$nextTick(() => {
        this.$refs.vuetable.refresh()
      })
    },
    limpar() {
      this.unidade = ''
      this.descritivo = ''
      this.status = ''

      this.$refs.vuetable.refresh()
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'compromissoDetails',
        value: 1
      })
    }
  }
}
</script>

<style scoped>
.icon {
    min-width: 14px;
}

.custom-font {
  font-size: 15px;
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}

.titulo-compromisso {
  font-size: 4.5em;
  font-weight: 900;
  color: #00615c;
  letter-spacing: -2.78px;
  margin: 30px 0 10px;
}

.descricao-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.descricao {
  flex: 1;
  margin-right: 15px;
  font-size: 2.5em;
  font-weight: 400;
  line-height: 1;
  color: #777;
}

.info-sub {
  font-size: 15px;
  color: #555;
  margin-bottom: 5px;
}

/* Label de status (reaproveitado) */
.label-status {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
}

.label-nao-iniciado {
  background-color: #999;
}

.label-em-andamento {
  background-color: #f0ad4e;
}

.label-concluido {
  background-color: #5cb85c;
}

.label-cancelado {
  background-color: #d9534f;
}

</style>

<style>
.truncate-multiline {
  display: -webkit-box;
  -webkit-line-clamp: 3; /* número de linhas desejadas */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/plano-governo/Details.vue